exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-cb0e3{padding:0}.modal-cb0e3 .ant-modal-content{padding:0}.modal-cb0e3 .ant-modal-header{margin-bottom:20px;padding:18px 24px;border-bottom:1px solid #f0f0f0}.modal-cb0e3 .ant-modal-body{padding:0 24px}.modal-cb0e3 .ant-modal-footer{padding:12px 24px;border-top:1px solid #f0f0f0}", ""]);

// Exports
exports.locals = {
	"modal": "modal-cb0e3"
};